import React from "react";
import Skeleton from "./Skeleton";
import "./loaders.css";

const FieldSkeleton = () => (
  <div className="mb-3">
    <Skeleton width="30%" height="0.7rem" className="mb-2" />
    <Skeleton width="100%" height="38px" />
  </div>
);

/**
 * Add/Edit form skeleton — label + input placeholders, optional rich-text
 * editor and image upload placeholders, in the standard 8/4 form layout.
 */
const FormSkeleton = ({
  fields = 4,
  showEditor = true,
  showImage = true,
}) => (
  <div className="row" aria-busy="true" aria-live="polite">
    <div className="col-lg-8">
      <div className="xc-skel-card mb-3">
        <Skeleton width="35%" height="1rem" className="mb-4" />
        <div className="row">
          {Array.from({ length: fields }).map((_, index) => (
            <div className="col-md-6" key={index}>
              <FieldSkeleton />
            </div>
          ))}
        </div>
        {showEditor ? (
          <div className="mt-2">
            <Skeleton width="25%" height="0.7rem" className="mb-2" />
            <Skeleton width="100%" height="220px" />
          </div>
        ) : null}
      </div>

      {showImage ? (
        <div className="xc-skel-card mb-3">
          <Skeleton width="20%" height="1rem" className="mb-3" />
          <div className="row">
            <div className="col-md-6">
              <Skeleton width="100%" height="170px" />
            </div>
            <div className="col-md-6">
              <Skeleton width="100%" height="170px" />
            </div>
          </div>
        </div>
      ) : null}
    </div>

    <div className="col-lg-4">
      <div className="xc-skel-card mb-3">
        <Skeleton width="45%" height="1rem" className="mb-4" />
        {Array.from({ length: 3 }).map((_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </div>
      <div className="xc-skel-card">
        <Skeleton width="45%" height="1rem" className="mb-4" />
        {Array.from({ length: 2 }).map((_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </div>
    </div>
  </div>
);

export default FormSkeleton;
